import { Injectable } from '@angular/core';
import { AuthService } from '../services/core/auth.services';
import { HttpRequest, HttpHandler, HttpEvent, HttpClient, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Globals } from '../shared/globals';
import { LoaderService } from '../services/commons/loading.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorErrorService implements HttpInterceptor {
  currentUser: any;
  basicAuthRoutes: string[] = ['logout', 'activateNewUser', 'updateFirstLogin', 'auth/room', 'room-services'];
  urlSkip = ['external-patients', 'null.json', 'room?pin', 'auth/login'];

  constructor(private loaderService: LoaderService, public auth: AuthService, private readonly globals: Globals, public http: HttpClient) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.currentUser = JSON.parse(localStorage.getItem('user'));
    if (this.currentUser) {
      localStorage.setItem('open', new Date().getTime().toString());

      this.globals.setSessionTimer();
      if (!this.skipBearerHeader(request)) {
        request = request.clone({
          setHeaders: {
            Authorization: 'Bearer ' + this.currentUser.token
          },
          withCredentials: false
        });
      }
    }

    return next.handle(request).pipe(
      catchError(error => {
        if (error.status === 401 || (!JSON.parse(localStorage.getItem('user')) && this.skipByUrl(request))) {
          this.globals.resetSessionIntervals();
          localStorage.setItem('close', new Date().getTime().toString());

          this.auth.logout();
        }
        if (
          (error.status >= 500 && error.status < 600) ||
          error.status === 0 ||
          (error.statusText && error.statusText.toLowerCase() === 'unknown error')
        ) {
          this.globals.throwServerError();
          this.loaderService.isLoading.next(false);
        }
        return throwError(error);
      })
    );
  }

  skipByUrl(request: HttpRequest<any>): boolean {
    for (const item of this.urlSkip) {
      if (request.url.includes(item)) {
        return false;
      }
    }
    return true;
  }
  skipBearerHeader(request: HttpRequest<any>): boolean {
    for (const item of this.basicAuthRoutes) {
      if (request.url.includes(item)) {
        return true;
      }
    }
    return false;
  }
}
